<template>
  <v-container data-app grid-list-xl fluid>
    <BaseWidget title="Gestão de Notas Fiscais">
      <v-tabs
        v-model="abaAtual"
        grow
        background-color="transparent"
        slider-color="transparent"
        class="custom-tabs no-slider"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :class="abaAtual === index ? 'tab-ativa' : 'tab-inativa'"
        >
          {{ tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="abaAtual">
        <v-tab-item>
          <NotasImportadas />
        </v-tab-item>
        <v-tab-item>
          <v-card flat class="pa-4">
            <p>Em breve outras funcionalidades aqui...</p>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </BaseWidget>
  </v-container>
</template>

<script>
import NotasImportadas from './NotasImportadas.vue';

export default {
  components: {
    NotasImportadas,
  },
  data() {
    return {
      abaAtual: 0,
      tabs: ['Notas Importadas', 'Outras Abas (futuro)'],
    };
  },
};
</script>

<style scoped>
.custom-tabs {
  border-bottom: 1px solid #e0e0e0;
}

.v-tab {
  text-transform: none;
  font-weight: 500;
  min-width: unset !important;
  padding: 12px 20px;
  margin-bottom: -1px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.tab-ativa {
  color: #1d4ed8 !important; /* Azul */
  border-bottom: 3px solid #1d4ed8 !important;
}

.tab-inativa {
  color: #9e9e9e !important; /* Cinza */
  border-bottom: 3px solid transparent;
}

/* Esconde o slider do Vuetify */
.no-slider >>> .v-tabs-slider {
  display: none !important;
}

</style>
